import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'

import { Checkbox as OriginCheckbox } from '../ui/checkbox'

import { cn } from '../../lib/utils'

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <OriginCheckbox
      className={cn('outline-none [&_svg]:!size-5', className)}
      {...props}
    />
  )
}

export { Checkbox }
